module.exports = __webpack_public_path__ + "img/longdevs_for_interns.b78d0f84.jpg";